export class CompanySubTask {
  Id: number;
  ClientCode: string;
  TaskGroupId: CompanySubTaskGroup;
  Position: number;
  Description: string;
}

export enum CompanySubTaskGroup {
  BeforePayroll = 1,
  AfterPayroll = 2
}
